<template>
    <main class="content container">
        <div class="content__top content__top--catalog">
            <h1 class="content__title">
                Каталог
            </h1>
            <span class="content__info">
        152 товара
      </span>
        </div>

        <div class="content__catalog">
            <ProductFilter :price-from.sync="filterPriceFrom" :price-to.sync="filterPriceTo" :category-id.sync="filterCategoryId" :color-id.sync="filterColorId"/>
            <section class="catalog">
                <div v-if="productsLoading===true">...Загрузка товаров</div>
                <div v-if="productsLoadingFalled===true">...Произошла ошибка при загрузке товаров<button @click.prevent="loadProducts">Попробывать еще раз</button></div>
                <ProductList  :products="products" ></ProductList>
                <BasePagination v-model="page" :count="countProducts" :per-page="productsPerPage" />



            </section>

        </div>
    </main>
</template>
<script>
    import ProductList from "./../components/ProductList";
    import BasePagination from "./../components/BasePagination";
    import ProductFilter from "./../components/productFilter";
    import  {API_BASE_URL} from"../config"
    import axios from 'axios';
import { mapActions } from 'vuex';



    export default {
        components:{ProductList :ProductList,BasePagination,ProductFilter},
        data(){
            return {
                filterPriceFrom:0,
                filterPriceTo:0,
                filterCategoryId:0,
                filterColorId:0,
                page: 1,
                productsPerPage: 3,
                productsData:null,
                productsLoading:false,
                productsLoadingFalled:false

            }},
        computed: {

            products() {
               return this.productsData
                   ?this.productsData.items.map(product=>{
                       return{
                           ...product,
                           image:product.image.file.url
                       }
                   })
                   :[]
            },
            countProducts(){
                return this.productsData? this.productsData.pagination.total:0;
            }

        },
        methods:{
            ...mapActions(['AppProductToCart']),
            loadProducts() {
                clearTimeout(this.loadProductsTimer);
                this.productsLoading=true;
                this.productsLoadingFalled=false;
                this.loadProductsTimer=setTimeout(() => {
                    axios.get(API_BASE_URL + `/api/products`, {
                        params: {
                            page: this.page,
                            limit: this.productsPerPage,
                            categoryId: this.filterCategoryId,
                            minPrice: this.filterPriceFrom,
                            maxPrice: this.filterPriceTo,
                            colorId:this.filterColorId,

                        }
                    })
                        .then(response => this.productsData = response.data)
                        .catch(()=>this.productsLoadingFalled=true)
                        .then(()=>this.productsLoading=false)
                },500)
            }
        },
        watch:{
            page(){
                this.loadProducts();
            },
            filterPriceFrom (){
        this.loadProducts(); },
            filterPriceTo(){
                this.loadProducts();
            },
            filterCategoryId(){
                this.loadProducts();
            },
            filterColorId(){
                this.loadProducts();
            },
        },
        created() {
            this.loadProducts();
        }
    }
</script>